// TAC Vesting 合约 ABI（只包含我们需要的函数）
export const TAC_VESTING_ABI = [
  {
    inputs: [{ name: '', type: 'string' }],
    name: 'info',
    outputs: [
      { name: 'choiceStartTime', type: 'uint64' },
      { name: 'stakingAccount', type: 'address' },
      { name: 'validatorAddress', type: 'string' },
      { name: 'userTotalRewards', type: 'uint256' },
      { name: 'unlocked', type: 'uint256' },
      { name: 'withdrawn', type: 'uint256' }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'stepDuration',
    outputs: [{ name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'merkleRoot',
    outputs: [{ name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ name: 'userTonAddress', type: 'string' }],
    name: 'getAvailable',
    outputs: [{ name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [{ name: 'userTonAddress', type: 'string' }],
    name: 'getUnlocked',
    outputs: [{ name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'VESTING_STEPS',
    outputs: [{ name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
  }
] as const;

export const DISTRIBUTION_ABI = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'delegatorAddress',
        type: 'address'
      },
      {
        internalType: 'string',
        name: 'validatorAddress',
        type: 'string'
      }
    ],
    name: 'delegationRewards',
    outputs: [
      {
        components: [
          {
            internalType: 'string',
            name: 'denom',
            type: 'string'
          },
          {
            internalType: 'uint256',
            name: 'amount',
            type: 'uint256'
          },
          {
            internalType: 'uint8',
            name: 'precision',
            type: 'uint8'
          }
        ],
        internalType: 'struct DecCoin[]',
        name: 'rewards',
        type: 'tuple[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  }
];

export const STAKINGI_ABI = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'delegatorAddress',
        type: 'address'
      },
      {
        internalType: 'string',
        name: 'validatorAddress',
        type: 'string'
      }
    ],
    name: 'unbondingDelegation',
    outputs: [
      {
        components: [
          {
            internalType: 'string',
            name: 'delegatorAddress',
            type: 'string'
          },
          {
            internalType: 'string',
            name: 'validatorAddress',
            type: 'string'
          },
          {
            components: [
              {
                internalType: 'int64',
                name: 'creationHeight',
                type: 'int64'
              },
              {
                internalType: 'int64',
                name: 'completionTime',
                type: 'int64'
              },
              {
                internalType: 'uint256',
                name: 'initialBalance',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'balance',
                type: 'uint256'
              },
              {
                internalType: 'uint64',
                name: 'unbondingId',
                type: 'uint64'
              },
              {
                internalType: 'int64',
                name: 'unbondingOnHoldRefCount',
                type: 'int64'
              }
            ],
            internalType: 'struct UnbondingDelegationEntry[]',
            name: 'entries',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct UnbondingDelegationOutput',
        name: 'unbondingDelegation',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  }
];
